/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol__ = _interopDefault(require('openlayers'));
var vectorLayer = _interopDefault(require('../mixin/vector-layer'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var minilo = require('../util/minilo');

var VectorTileLayer = __ol__.layer.VectorTile;
var RENDER_MODES = ['vector', 'image', 'hybrid'];

var props = {
  renderMode: {
    type: String,
    default: 'hybrid',
    validator: function validator(val) {
      return RENDER_MODES.includes(val);
    }
  },
  preload: {
    type: Number,
    default: 0
  }
};

var methods = {
  /**
   * @return {ol.layer.Vector}
   * @protected
   */
  createLayer: function createLayer() {
    return new VectorTileLayer({
      id: this.id,
      minResolution: this.minResolution,
      maxResolution: this.maxResolution,
      opacity: this.opacity,
      visible: this.visible,
      preload: this.preload,
      extent: this.extent,
      zIndex: this.zIndex,
      updateWhileAnimating: this.updateWhileAnimating,
      updateWhileInteracting: this.updateWhileInteracting,
      source: this._source,
      renderMode: this.renderMode,
      renderBuffer: this.renderBuffer,
      renderOrder: this.renderOrder,
      declutter: this.declutter
    });
  }
};

var Layer = {
  name: 'vl-layer-vector-tile',
  mixins: [vectorLayer],
  props: props,
  methods: methods
};

var index = {
  Layer: Layer,
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options = minilo.pick(options, 'dataProjection');
    _Object$assign(Layer, options);

    Vue.component(Layer.name, Layer);
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/vector-tile-layer/index.js
// module id = 1496
// module chunks = 1